

import axios from "axios";
import config from "../api-config/config";

const proxyServer = config.serverApiHeavy + "reports2/idling";
 

export const GetIdlingByVehicles = (userToken, vehicleIds, startTime, endTime, secondsOrAbove) => {
  const criterion = { userToken, vehicleIds, startTime, endTime, secondsOrAbove };
  return axios
    .post(proxyServer + "/get-by-vehicles", { criterion })
    .then(res => {
      return res.data;
    })
    .catch(err => {
      return err;
    });
};

 